import React from 'react';
import PropTypes from 'prop-types';

import { isEmpty } from 'lodash';
import { Meteor } from 'meteor/meteor';
import { withTracker } from 'meteor/react-meteor-data';
import {
  Box,
  Checkbox,
  FormControl,
  IconButton,
  InputLabel,
  List,
  ListItem,
  ListItemText,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import ShareIcon from '@mui/icons-material/Share';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Connectors from '../../../api/Connectors/Connectors';
import Sources from '../../../api/Sources/Sources';

import ShowListIconsFontawesome from '../../components/ShowListIconsFontawesome';
import { LIBRARY_ICON_TYPES } from '../../../api/AnnotationTemplates/AnnotationTemplates';

const MapsAdvancedTableSourceField = props => {
  const {
    listComponentsAdvanced,
    setListComponentsAdvanced,
    setSettingsAdvanced,
    settingsAdvanced,
    allSources,
    connectorList
  } = props;

  const [localSettings, setLocalSettings] = React.useState(settingsAdvanced.tableSource);
  const [iconFontawesome, setIconFontawesome] = React.useState(
    listComponentsAdvanced.TableSourceComponent.iconFontawesome
  );
  const [iconSvg, setIconSvg] = React.useState(listComponentsAdvanced.TableSourceComponent.iconSvg);
  const [libraryIcon, setLibraryIcon] = React.useState(
    listComponentsAdvanced.TableSourceComponent.libraryIcon
  );
  const [nameComponent, setNameComponent] = React.useState(
    listComponentsAdvanced.TableSourceComponent.name
  );
  const [openModal, setOpenModal] = React.useState(false);
  const [connectorSelected, setConnectorSelected] = React.useState('');

  const handleConnectorChange = event => {
    setConnectorSelected(event.target.value);
  };

  const handleToggle = item => {
    const currentIndex = localSettings.sources.indexOf(item._id);
    const newChecked = [...localSettings.sources];

    if (currentIndex === -1) {
      newChecked.push(item._id);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    if (!isEmpty(localSettings.defaultSource)) {
      setLocalSettings({ ...localSettings, defaultSource: item._id, sources: newChecked });
      setSettingsAdvanced(prev => ({
        ...prev,
        tableSource: {
          ...prev.tableSource,
          defaultSource: item._id,
          sources: newChecked
        }
      }));
    } else {
      setLocalSettings({ ...localSettings, sources: newChecked });
      setSettingsAdvanced(prev => ({
        ...prev,
        tableSource: {
          ...prev.tableSource,
          sources: newChecked
        }
      }));
    }
  };

  const filteredSources = connectorSelected
    ? allSources.filter(source => source.connectorId === connectorSelected)
    : [];

  return (
    <Box display="flex" width="100%" gab={1} justifyContent="space-around">
      <Box display="column" width="40%" gab={1}>
        <Box
          component="form"
          sx={{
            display: 'flex',
            mb: 2,
            width: '100%'
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            id="outlined-required"
            label="Nombre del componente"
            size="small"
            value={nameComponent}
            onChange={event => setNameComponent(event.target.value)}
            mb={2}
            fullWidth
          />
          <IconButton
            onClick={() => setOpenModal(true)}
            style={{
              color: '#2A3F90'
            }}
          >
            {!isEmpty(libraryIcon) ? (
              <>
                {libraryIcon === LIBRARY_ICON_TYPES.FONTAWESOME && (
                  <FontAwesomeIcon icon={iconFontawesome} />
                )}
                {libraryIcon === LIBRARY_ICON_TYPES.SVG && (
                  <img
                    src={iconSvg}
                    alt={iconFontawesome}
                    style={{ marginRight: '5px', width: '20px', height: '20px' }}
                  />
                )}
              </>
            ) : (
              <ShareIcon />
            )}
          </IconButton>
          <IconButton
            onClick={() =>
              setListComponentsAdvanced({
                ...listComponentsAdvanced,
                TableSourceComponent: {
                  name: nameComponent,
                  show: listComponentsAdvanced.TableSourceComponent.show
                }
              })
            }
            style={{
              color: '#2A3F90'
            }}
          >
            <SaveIcon />
          </IconButton>
          <ShowListIconsFontawesome
            openModal={openModal}
            setOpenModal={setOpenModal}
            handleIconSelected={(elementIcon, library) => {
              if (library === LIBRARY_ICON_TYPES.FONTAWESOME) {
                setIconFontawesome(elementIcon);
              } else if (library === LIBRARY_ICON_TYPES.SVG) {
                setIconSvg(elementIcon.url);
                setIconFontawesome(elementIcon.name);
              }
              setLibraryIcon(library);
            }}
            selectedIcon={listComponentsAdvanced.TableSourceComponent.iconFontawesome}
            startLibrary={listComponentsAdvanced.TableSourceComponent.libraryIcon}
            svg={listComponentsAdvanced.TableSourceComponent.iconSvg}
            startCategorySvg={listComponentsAdvanced.TableSourceComponent.cetegorySvg}
          />
        </Box>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="connector-select-label">Select Connector</InputLabel>
          <Select
            labelId="connector-select-label"
            id="connector-select"
            size="small"
            value={connectorSelected}
            onChange={handleConnectorChange}
            label="Select Connector"
          >
            {connectorList.map(connector => (
              <MenuItem key={connector._id} value={connector._id}>
                {connector.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="source-select-label">Default Source</InputLabel>
          <Select
            labelId="source-select-label"
            id="source-select"
            size="small"
            value={localSettings.defaultSource}
            onChange={event => {
              setLocalSettings({ ...localSettings, defaultSource: event.target.value });
              setSettingsAdvanced(prev => ({
                ...prev,
                tableSource: {
                  ...prev.tableSource,
                  defaultSource: event.target.value
                }
              }));
            }}
            label="Default Source"
          >
            {allSources
              .filter(source => localSettings.sources.includes(source._id))
              .map(source => (
                <MenuItem key={source._id} value={source._id}>
                  {source.name}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
        <Box display="column" width="75%" spacing={1}>
          <Typography>Sources</Typography>
          <div style={{ maxHeight: '50vh', overflow: 'auto' }}>
            <List>
              {filteredSources.map(item => (
                <ListItem key={item._id} button onClick={() => handleToggle(item)}>
                  <Checkbox
                    edge="start"
                    checked={localSettings.sources.includes(item._id)}
                    tabIndex={-1}
                    disableRipple
                    sx={{
                      color: '#2A3F90',
                      '&.Mui-checked': {
                        color: '#2A3F90'
                      }
                    }}
                  />
                  <ListItemText primary={item.name} secondary={item.path} />
                </ListItem>
              ))}
            </List>
          </div>
        </Box>
      </Box>
      <Box display="column" width="40%" gab={1} />
    </Box>
  );
};

export default withTracker(() => {
  const sourcesSub = Meteor.subscribe('sources');
  const connectorsSub = Meteor.subscribe('connectors');

  return {
    loading: !sourcesSub.ready() || !connectorsSub.ready(),
    allSources: Sources.find({ deleted: { $eq: 'no' } }).fetch(),
    connectorList: Connectors.find({ deleted: { $eq: 'no' } }).fetch()
  };
})(MapsAdvancedTableSourceField);

MapsAdvancedTableSourceField.defaultProps = {
  setListComponentsAdvanced: () => {},
  allSources: [],
  connectorList: []
};

MapsAdvancedTableSourceField.propTypes = {
  listComponentsAdvanced: PropTypes.object.isRequired,
  setListComponentsAdvanced: PropTypes.func,
  allSources: PropTypes.array,
  connectorList: PropTypes.array,
  settingsAdvanced: PropTypes.object.isRequired,
  setSettingsAdvanced: PropTypes.func.isRequired
};
